module.exports = __webpack_public_path__ + "files/eb69d2a2c485c8e792dffee466bd287f.png";